<ul class="nav nav-tabs">
    <ng-container *ngFor="let derivative of user?.menusList">
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button"
                aria-expanded="false">{{derivative.menuName}}</a>
            <div class="dropdown-menu">
                <a class="dropdown-item" [routerLink]="'/'+derivative.menuCode+'/'+data.menuCode"
                    *ngFor="let data of derivative?.userMenusImpls"
                    (click)="setDerivative('/'+derivative.menuCode+'/'+data.menuCode);"
                    [ngClass]="(data.isAccessAllowed=='N' || data.isActive=='N')?'disabled':''">{{data.menuName}}</a>
            </div>
        </li>
    </ng-container>
</ul>